import { IconBaseProps } from '@meronex/icons';
import { RequireExactlyOne } from 'type-fest';
import React, { forwardRef } from 'react';
import { icons, isIconName, TIconName, TIconType } from './iconMap';
import { Box } from '@apia/theme';

type TIconArgs = RequireExactlyOne<{
  icon: TIconName | TIconType;
  name: TIconName;
}>;

export const Icon = forwardRef<
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  any,
  TIconArgs & IconBaseProps & { title: string; imageSrc?: string }
>(({ className, icon, name, size, ...props }, ref) => {
  const IconComponent =
    // eslint-disable-next-line no-nested-ternary
    icon === undefined ? icons[name] : isIconName(icon) ? icons[icon] : icon;

  const sx = React.useMemo(() => {
    return {
      '&.icon__wrapper': {
        display: 'inline-flex',
        p: 0,
        m: 0,

        svg: {
          width: size,
          height: size,
        },
      },
    };
  }, [size]);

  return (
    <Box
      ref={ref}
      as="span"
      className={`icon__wrapper ${className ?? ''}`}
      sx={sx}
    >
      {props.imageSrc ? (
        <img
          aria-label={props['aria-label'] ?? props.title}
          style={{
            height: size,
            width: size,
          }}
          src={props.imageSrc}
        />
      ) : (
        <IconComponent
          {...props}
          aria-label={props['aria-label'] ?? props.title}
        />
      )}
    </Box>
  );
});
